/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_CopiedInputs */

const bn_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কপি করা হয়েছে`)
};

const de_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiert`)
};

const el_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αντιγράφηκε`)
};

const en_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

const es_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado`)
};

const fr_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copié`)
};

const hi_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉपी किया गया`)
};

const hu_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Másolva`)
};

const id_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disalin`)
};

const it_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiato`)
};

const ja_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーされました`)
};

const ko_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복사됨`)
};

const nl_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekopieerd`)
};

const pl_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiowano`)
};

const pt_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado`)
};

const ru_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировано`)
};

const sv_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopierade`)
};

const tr_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopyalandı`)
};

const uk_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопійовано`)
};

const vi_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã sao chép`)
};

const zh_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制`)
};

const zh_hant_game_copied = /** @type {(inputs: Game_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已複製`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Game_CopiedInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_copied = /** @type {((inputs?: Game_CopiedInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_CopiedInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_copied(inputs)
	if (locale === "de") return de_game_copied(inputs)
	if (locale === "el") return el_game_copied(inputs)
	if (locale === "en") return en_game_copied(inputs)
	if (locale === "es") return es_game_copied(inputs)
	if (locale === "fr") return fr_game_copied(inputs)
	if (locale === "hi") return hi_game_copied(inputs)
	if (locale === "hu") return hu_game_copied(inputs)
	if (locale === "id") return id_game_copied(inputs)
	if (locale === "it") return it_game_copied(inputs)
	if (locale === "ja") return ja_game_copied(inputs)
	if (locale === "ko") return ko_game_copied(inputs)
	if (locale === "nl") return nl_game_copied(inputs)
	if (locale === "pl") return pl_game_copied(inputs)
	if (locale === "pt") return pt_game_copied(inputs)
	if (locale === "ru") return ru_game_copied(inputs)
	if (locale === "sv") return sv_game_copied(inputs)
	if (locale === "tr") return tr_game_copied(inputs)
	if (locale === "uk") return uk_game_copied(inputs)
	if (locale === "vi") return vi_game_copied(inputs)
	if (locale === "zh") return zh_game_copied(inputs)
	return zh_hant_game_copied(inputs)
});